import React from 'react';

const AWS_Serverless = () => {
  return (
    <div>
      <h1>AWS_Serverless</h1>
      <p>This is the AWS_Serverless component.</p>
    </div>
  );
};

export default AWS_Serverless;
